import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ISaleStatus } from '../../core/services/invoicing.service';
import { SalesStatusComponent } from '../../dashboard/invoicing/sales-status/sales-status.component';
import { ButtonComponent } from '../../shared-with-client/button/button.component';
import { ClipboardInputComponent } from '../clipboard-input/clipboard-input.component';
import { MerchantCurrencyPipe } from '../pipes/merchant-currency.pipe';
import { PaymentMethodPipe } from '../pipes/payment-method.pipe';

/**
 * Booking sale summary when the sales module is on
 * (status, collected payments, outstanding balance, total, sale CTAs, pre-payment link).
 */
@Component({
    selector: 'app-booking-sale-payments-card',
    standalone: true,
    imports: [
        TranslatePipe,
        DatePipe,
        MerchantCurrencyPipe,
        PaymentMethodPipe,
        SalesStatusComponent,
        ButtonComponent,
        ClipboardInputComponent,
    ],
    templateUrl: './booking-sale-payments-card.component.html',
})
export class BookingSalePaymentsCardComponent {
    @Input({ required: true }) sale!: any;
    @Input() totalPriceCents: number | null = null;
    @Input() canViewSaleDetails = false;
    @Input() isInvoicingActive = false;
    @Input() showPrePaymentLink = false;
    @Input() prePaymentLinkExpanded = false;
    @Input() prePaymentLinkLoading = false;
    @Input() prePaymentLinkUrl = '';

    @Output() seeSaleDetails = new EventEmitter<void>();
    @Output() editSale = new EventEmitter<void>();
    @Output() togglePrePaymentLink = new EventEmitter<void>();

    readonly ISaleStatus = ISaleStatus;

    get payments() {
        return this.sale?.salePayments ?? [];
    }

    get showSeeRegister(): boolean {
        return Boolean(this.sale?.code && this.canViewSaleDetails);
    }

    get showEditSale(): boolean {
        if (this.sale?.status === ISaleStatus.DRAFT) {
            return true;
        }

        return Boolean(
            !this.isInvoicingActive
            && this.canViewSaleDetails
            && this.sale?.code
            && this.sale?.status !== ISaleStatus.CANCELLED,
        );
    }

    get footerJustifyBetween(): boolean {
        return this.showSeeRegister && this.showEditSale;
    }
}
